import React, { useState, useEffect } from 'react';
import TrainersNavbar from './TrainerNavbar';
import '../styles/TrainersTimetable.css'; // Ensure the CSS file is inside the src/styles directory

const TrainersTimetable = () => {
  const [trainerName, setTrainerName] = useState('');
  const [assignedSubjects, setAssignedSubjects] = useState([]);
  const [timetables, setTimetables] = useState({ Excellent: [], Capable: [], Idle: [] });

  useEffect(() => {
    const fetchAssignedSubjects = async () => {
      try {
        const trainerName = localStorage.getItem('trainerName');
        setTrainerName(trainerName);

        const response = await fetch(`https://backend-main-4.onrender.com/api/assigned-subjects?trainer=${trainerName}`);
        if (response.ok) {
          const data = await response.json();
          setAssignedSubjects(data);
        } else {
          throw new Error('Failed to fetch assigned subjects.');
        }
      } catch (error) {
        console.error('Error fetching assigned subjects:', error);
      }
    };

    fetchAssignedSubjects();
  }, []);

  useEffect(() => {
    const fetchTimetables = async () => {
      const groups = ['Excellent', 'Capable', 'Idle'];
      const fetchedTimetables = {};

      for (const group of groups) {
        try {
          const response = await fetch(`https://backend-main-4.onrender.com/api/fetch-timetable?group=${group}`);
          if (response.ok) {
            const data = await response.json();
            fetchedTimetables[group] = data;
          } else {
            throw new Error(`Failed to fetch timetable for ${group}.`);
          }
        } catch (error) {
          console.error(`Error fetching timetable for ${group}:`, error);
        }
      }

      setTimetables(fetchedTimetables);
    };

    fetchTimetables();
  }, []);

  return (
    <div>
      <TrainersNavbar />
      <div className="container mt-5">
        <h2 className="text-center">Assigned Subjects</h2>
        <p className="welcome-message">Welcome, {trainerName}!</p>
        {assignedSubjects.length > 0 ? (
          <table className="subjects-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Group</th>
              </tr>
            </thead>
            <tbody>
              {assignedSubjects.map((subject, index) => {
                return (
                  <tr key={index}>
                    <td>{subject.subject}</td>
                    <td>{subject.group}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <p className="no-subjects-message">No subjects assigned yet.</p>
        )}
        <div className="timetables mt-5">
          {['Excellent', 'Capable', 'Idle'].map(group => (
            <div key={group} className="timetable-section">
              <h3 className="text-center">{group} Group Timetable</h3>
              {Object.keys(timetables[group]).length > 0 ? (
                <table className="timetable-table">
                  <thead>
                    <tr>
                      <th>Day</th>
                      {timetables[group][Object.keys(timetables[group])[0]].map((_, index) => (
                        <th key={index}>{index + 1} Period</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(timetables[group]).map(([day, periods], index) => (
                      <tr key={index}>
                        <td>{day}</td>
                        {periods.map((period, idx) => (
                          <td key={idx}>{period.subject}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>No timetable available for {group} group.</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrainersTimetable;
